import React from 'react';
import { HeroTrustBar } from './HeroTrustBar';
// Re-export the same component — About page uses the full trust wall
export function EcosystemGrid() {
  return <HeroTrustBar data-id="element-48" />;
}